import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import './ConfirmationModal.css';

const ConfirmationModal = ({
    show,
    onHide,
    title,
    message = "Do you really want to perform this action?",
    confirmLabel = "Confirm",
    confirmVariant = "danger",
    cancelLabel = "Cancel",
    onConfirm,
    width = "400px",

}) => {
    return (
        <Modal
            className="confirmation-modal"
            centered
            show={show}
            onHide={onHide}
            backdrop="static"
            keyboard={false}
            style={{ '--modal-width': width }}
        >
            {title && (
                <Modal.Header>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
            )}
            <Modal.Body>
                <Modal.Title>{message}</Modal.Title>
            </Modal.Body>
            <Modal.Footer>
                <div className="button-container">
                    <Button variant={cancelLabel === "Cancel" ? "secondary" : "light"} className="confirmation-cancel-btn" onClick={onHide}>
                        {cancelLabel}
                    </Button>
                    <Button variant={confirmVariant} className='confirmation-confirm-btn' onClick={onConfirm}>
                        {confirmLabel}
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmationModal;
